import _ from "../../shared/utils/ObjectUtils";

let DashboardUtils = {

    layoutIsTheSameAsBefore(originalLayout, newLayout) {
        let result = true;

        if(originalLayout.length !== newLayout.length || _.isNilOrEmpty(originalLayout) || _.isNilOrEmpty(newLayout)) {
            return false;
        }

        for (let widget of originalLayout) {
            const i = newLayout.findIndex( newLayoutWidget => newLayoutWidget.i === widget.i.toString() );
            if(i === -1 || newLayout[i].w !== widget.w || newLayout[i].h !== widget.h || newLayout[i].x !== widget.x || newLayout[i].y !== widget.y) {
                result = false;
                break;
            }
        }
        return result;
    },

    widgetIsTheSameAsBefore(widget, newLayout) {
        return widget.configs.columnIndex.toString() === newLayout.x.toString() && widget.configs.rowIndex.toString() === newLayout.y.toString() &&
            widget.configs.widgetHeight.toString() === newLayout.h.toString() && widget.configs.widgetWidth.toString() === newLayout.w.toString();
    },
};

export default DashboardUtils;